import { createSlice } from "@reduxjs/toolkit";

import api, { post, patch } from "../../helpers/axios";
import {
  PATCH_USER_DETAILS,
  POST_CHANGE_PASSWORD,
} from "../../helpers/url_helpers";
import { setLocalStorage } from "../../helpers/utils";

const initialState = {
  loading: false,
  profileEditResponse: "",
  passwordChangeResponse: "",
  editProfileError: "",
};

const editEmployeeProfile = createSlice({
  name: "editEmployeeProfile",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload.loading;
    },
    setProfileEditResponse: (state, action) => {
      state.employeeDashboardData = action.payload.employeeDashboardData;
    },
    setPasswordChangeResponse: (state, action) => {
      state.employeeDashboardData = action.payload.employeeDashboardData;
    },
    setError: (state, action) => {
      state.editProfileError = action.payload.editProfileError;
    },
  },
});

export const {
  setLoading,
  setProfileEditResponse,
  setPasswordChangeResponse,
  setError,
} = editEmployeeProfile.actions;
export default editEmployeeProfile.reducer;

export const editEmployeeProfileDetails =
  (payload, callback) => async (dispatch) => {
    try {
      dispatch(setLoading({ loading: true }));
      dispatch(setProfileEditResponse({ profileEditResponse: "" }));
      // PATCH Edit user details api call
      const response = await api.patch(PATCH_USER_DETAILS, payload);
      if (response?.error) {
        dispatch(
          setError({
            editProfileError: response?.error,
          })
        );
      } else {
        dispatch(
          setProfileEditResponse({ profileEditResponse: response.data?.data })
        );
        setLocalStorage("USER_DETAILS", response?.data?.data);
        if (callback) callback();
      }
      dispatch(setLoading({ loading: false }));
    } catch (error) {
      dispatch(setLoading({ loading: false }));
      dispatch(
        setError({
          editProfileError: error,
        })
      );
    }
  };

export const changePassword = (payload, callback1) => async (dispatch) => {
  try {
    dispatch(setLoading({ loading: true }));
    dispatch(setPasswordChangeResponse({ passwordChangeResponse: "" }));
    // api call
    const response = await api.post(POST_CHANGE_PASSWORD, payload);
    if (response.data.error) {
      dispatch(
        setError({
          editProfileError: response.data.error,
        })
      );
    } else {
      dispatch(
        setPasswordChangeResponse({
          passwordChangeResponse: response.data?.data,
        })
      );
      callback1 && callback1();
    }
    dispatch(setLoading({ loading: false }));
  } catch (error) {
    dispatch(setLoading({ loading: false }));
    error && dispatch(setError({ editProfileError: error }));
  }
};

export const clearError = () => async (dispatch) => {
  dispatch(setError({ editProfileError: {} }));
};
